<template>
	<div class="net-worth-wrap">

    <h2>{{ _translate('netWorth.title') }}</h2>

    <div class="report__client-info" v-html="showClientInfo()"></div>    

    <div class="report-content">

      <div class="report__disclaimer" v-html="showDisclaimer()"></div>

      <Checkbox v-if="hasSpouse()" id="spouseReport" :label="_translate('netWorth.spouseReport')" field="details.spouseReport" value="true"></Checkbox>

      <div v-if="setStoreTables()" class="net-worth__section net-worth__total">
        {{ _translate('netWorth.totalNetWorth') }}: <span class="net-worth__value net-worth__total-value" v-html="getDollarFormat(getNetWorth())"></span>
        <Chart v-if="showNetWorthChart()" type="bar" stacked="true" :data="chartNetWorth()" id="netWorth"></Chart>
      </div>

      <div class="net-worth__assets">
        <h3 class="net-worth__type-heading">{{ _translate('netWorth.assets') }} <span class="net-worth__value" v-html="getDollarFormat(getTypeTotal('assets'))"></span></h3>
        <Chart v-if="showTotalAreaChart()" type="pie" :data="chartTotalArea()" id="netWorthAssets"></Chart>
        <div class="report__disclaimer" v-html="showDisclaimer()"></div>
        <div v-if="getSectionTotal('liquid', 'assets') > 0" class="net-worth__section">
          <h4 class="net-worth__section-heading">
            <span class="net-worth__section-label">{{ _translate('netWorth.liquidAssets') }}</span>
            <span class="net-worth__value" v-html="getDollarFormat(getSectionTotal('liquid', 'assets'))"></span>
          </h4>
          <ul class="net-worth__list">
            <li v-if="getRepeaterTotal('savings.open.chequing', 'balance') > 0" class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.chequingAccounts') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.open.chequing', 'balance', false, true)"></span>
            </li>

            <li v-if="getRepeaterTotal('savings.open.savings', 'balance') > 0" class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.savingsAccounts') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.open.savings', 'balance', false, true)"></span>
            </li>
          </ul>
        </div>

        <div v-if="getSectionTotal('semiliquid', 'assets') > 0" class="net-worth__section">
          <h4 class="net-worth__section-heading">
          <span class="net-worth__section-label">{{ _translate('netWorth.semiliquidAssets') }}</span>
            <span class="net-worth__value" v-html="getDollarFormat(getSectionTotal('semiliquid', 'assets'))"></span>
          </h4>
          <ul class="net-worth__list">
            <li v-if="getRepeaterTotal('savings.open.tfsa', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.tfsasTotal') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.open.tfsa', 'balance', false, true)"></span>
            </li>

<!--             <li v-if="getRepeaterTotal('savings.open.bonds', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">Bonds Total</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.open.bonds', 'balance', false, true)"></span>
            </li> -->

            <li v-if="getRepeaterTotal('savings.open.stocks', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.stocksTotal') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.open.stocks', 'balance', false, true)"></span>
            </li>

            <li v-if="getRepeaterTotal('savings.open.mutualFunds', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.mutualFundsTotal') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.open.mutualFunds', 'balance', false, true)"></span>
            </li>

<!--             <li v-if="getRepeaterTotal('savings.open.gics', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">GIC Total</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.open.gics', 'balance', false, true)"></span>
            </li> -->

            <li v-if="getRepeaterTotal('savings.open.other', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.otherSecuritiesTotal') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.open.other', 'balance', false, true)"></span>
            </li>

          </ul>
        </div>

        <div v-if="getSectionTotal('retirement', 'assets') > 0" class="net-worth__section">
          <h4 class="net-worth__section-heading">
          <span class="net-worth__section-label">{{ _translate('netWorth.retirementSavings') }}</span>
            <span class="net-worth__value" v-html="getDollarFormat(getSectionTotal('retirement', 'assets'))"></span>
          </h4>      
          <ul class="net-worth__list">

<!--             <li v-if="getRepeaterTotal('savings.registered.savings', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">Savings Accounts Total</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.registered.savings', 'balance', false, true)"></span>
            </li>

            <li v-if="getRepeaterTotal('savings.registered.bonds', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">Stocks Total</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.registered.bonds', 'balance', false, true)"></span>
            </li> -->

            <li v-if="getRepeaterTotal('savings.registered.mutualFunds', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.mutualFundsTotal') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.registered.mutualFunds', 'balance', false, true)"></span>
            </li>

<!--             <li v-if="getRepeaterTotal('savings.registered.gics', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">GIC Total</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.registered.gics', 'balance', false, true)"></span>
            </li> -->

            <li v-if="getRepeaterTotal('savings.registered.other', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.other') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.registered.other', 'balance', false, true)"></span>
            </li>

            <li v-if="getRepeaterTotal('savings.registered.dpspEsopGrsp', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.dpspEsopGrsp') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.registered.dpspEsopGrsp', 'balance', false, true)"></span>
            </li>

            
            <li v-if="getRepeaterTotal('savings.registered.rrif', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.rrifs') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.registered.rrif', 'balance', false, true)"></span>
            </li>

            <li v-if="getRepeaterTotal('savings.lockedin.employerPension', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.employerPensionPlan') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.lockedin.employerPension', 'balance', false, true)"></span>
            </li>

            <li v-if="getRepeaterTotal('savings.lockedin.lockedRrsp', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.lockedinRrsp') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('savings.lockedin.lockedRrsp', 'balance', false, true)"></span>
            </li>

          </ul>
        </div>

        <div v-if="getSectionTotal('realestate', 'assets') > 0" class="net-worth__section">
          <h4 class="net-worth__section-heading">
          <span class="net-worth__section-label">{{ _translate('netWorth.realEstate') }}</span>
            <span class="net-worth__value" v-html="getDollarFormat(getSectionTotal('realestate', 'assets'))"></span>
          </h4>        
          <ul class="net-worth__list">

            <li v-if="getRepeaterTotal('assets.realEstate.home', 'value') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.homeValue') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('assets.realEstate.home', 'value', false, true)"></span>
            </li>

            <li v-if="getRepeaterTotal('assets.realEstate.other', 'value') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.otherRealEstateValue') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('assets.realEstate.other', 'value', false, true)"></span>
            </li>

          </ul>
        </div>

        <div v-if="getSectionTotal('property', 'assets') > 0" class="net-worth__section">
          <h4 class="net-worth__section-heading">
          <span class="net-worth__section-label">{{ _translate('netWorth.personalProperty') }}</span>
            <span class="net-worth__value" v-html="getDollarFormat(getSectionTotal('property', 'assets'))"></span>
          </h4>      
        </div>

        <div v-if="getSectionTotal('other', 'assets') > 0" class="net-worth__section">
          <h4 class="net-worth__section-heading">
          <span class="net-worth__section-label">{{ _translate('netWorth.taxDeferredAssets') }}</span>
            <span class="net-worth__value" v-html="getDollarFormat(getSectionTotal('other', 'assets'))"></span>
          </h4>      
        </div>

        <div v-if="getSectionTotal('business', 'assets') > 0" class="net-worth__section">
          <h4 class="net-worth__section-heading">
          <span class="net-worth__section-label">{{ _translate('netWorth.businessInterests') }}</span>
            <span class="net-worth__value" v-html="getDollarFormat(getSectionTotal('business', 'assets'))"></span>
          </h4>      
        </div>
      </div>

      <div class="net-worth__liabilities">
       
        <h3 class="net-worth__type-heading">{{ _translate('netWorth.liabilities') }} <span class="net-worth__value" v-html="getDollarFormat(getTypeTotal('liabilities'))"></span></h3>
        <Chart v-if="showTotalAreaChart('liabilities')" type="pie" :data="chartTotalArea('liabilities')" id="netWorthLiabilities"></Chart>
        <div class="report__disclaimer" v-html="showDisclaimer()"></div>
        <div v-if="getSectionTotal('shortterm', 'liabilities') < 0" class="net-worth__section">
          <h4 class="net-worth__section-heading">
          <span class="net-worth__section-label">{{ _translate('netWorth.shortTermDebt') }}</span>
            <span class="net-worth__value" v-html="getDollarFormat(getSectionTotal('shortterm', 'liabilities'))"></span>
          </h4>        
          <ul class="net-worth__list">

            <li v-if="getRepeaterTotal('debt.shortTerm.creditCards', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.creditCards') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('debt.shortTerm.creditCards', 'balance', true, true)"></span>
            </li>

            <li v-if="getRepeaterTotal('debt.shortTerm.carLoans', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.carLoans') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('debt.shortTerm.carLoans', 'balance', true, true)"></span>
            </li>

            <li v-if="getRepeaterTotal('debt.shortTerm.lineOfCredit', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.lineOfCredit') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('debt.shortTerm.lineOfCredit', 'balance', true, true)"></span>
            </li>

            <li v-if="getRepeaterTotal('debt.shortTerm.other', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.otherLiabilities') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('debt.shortTerm.other', 'balance', true, true)"></span>
            </li>

          </ul>
        </div>

        <div v-if="getSectionTotal('longterm', 'liabilities') < 0" class="net-worth__section">
          <h4 class="net-worth__section-heading">
          <span class="net-worth__section-label">{{ _translate('netWorth.longTermDebt') }}</span>
            <span class="net-worth__value" v-html="getDollarFormat(getSectionTotal('longterm', 'liabilities'))"></span>
          </h4>        
          <ul class="net-worth__list">

            <li v-if="getRepeaterTotal('debt.longTerm.mortgageHome', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.mortgageOnHome') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('debt.longTerm.mortgageHome', 'balance', true, true)"></span>
            </li>

            <li v-if="getRepeaterTotal('debt.longTerm.mortgageOther', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.otherMortgages') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('debt.longTerm.mortgageOther', 'balance', true, true)"></span>
            </li>

            <li v-if="getRepeaterTotal('debt.longTerm.investmentLoans', 'balance') > 0"  class="net-worth__list-item">
              <span class="net-worth__list-label">{{ _translate('netWorth.investmentLoans') }}</span>
              <span class="net-worth__value" v-html="getRepeaterTotal('debt.longTerm.investmentLoans', 'balance', true, true)"></span>
            </li>

          </ul>
        </div> 

      </div>  

    </div>   

  </div>
</template>

<script>

import Icon from '../Icon.vue'
import Chart from '../Chart.vue'
import Checkbox from '../Checkbox.vue'

export default {


	components: {

    Icon,
    Chart,
    Checkbox,

	}, 

  /**
   * METHODS
   * -------
   * 
   * These are the methods that are available to the 
   * component.
   */
   
  methods : {

    /**
     * METHOD: setStoreTables()
     * @return {boolean} true
     *
     * The function is intended to define tables based on the information in the store, not to set values 
     * in the store. This is a key difference, as we want the data in these tables to be a vanilla JavaScript 
     * object, not a Vue object. The reason here is to avoid unintentional reactive loops that can cause the 
     * component to continually update itself when the store is updated.
     *
     * The table that is set contains all of the data from the assets and liability items within the
     * client profile, along with a total net worth value. 
     *
     * Always returns true;
     *
     */
    setStoreTables() {

      var assets = {},
          assetsBreakdown = {},
          liabilities = {},
          liabilitiesBreakdown = {},
          total = 0,
          val = 0,
          valBreakdown, account;

      for ( var x in this.$data.worth.assets ) {

        assets[x] = {};
        assetsBreakdown[x] = [];

        for ( var y in this.$data.worth.assets[x] ) {

          var key = this.$data.worth.assets[x][y].key;
          val = this.getRepeaterValues(
            this.$data.worth.assets[x][y].field,
            this.$data.worth.assets[x][y].totalby
          );

          total += Number(val.total);

          assets[x][key] = val;
          assetsBreakdown[x][key] = [];

          account = this.$store.getters.getRepeaterData({field: this.$data.worth.assets[x][y].field})
          for ( var r in account ) {
            assetsBreakdown[x][key][r] = {
              spouse: false
            }
            for ( var a in account[r] ) {
              assetsBreakdown[x][key][r][account[r][a].field] = account[r][a].value;
            }
          }
          if ( this.hasSpouse() ) {
            if ( this.useSpouse() ) {
              var r = assetsBreakdown[x][key].length
              account = this.$store.getters.getRepeaterData({field: this.$data.worth.assets[x][y].field, spouse: true})
              for ( var s in account ) {
                var index = Number(r) + Number(s);
                    index += '';
                assetsBreakdown[x][key][index] = {
                  spouse: true
                }
                for ( var a in account[s] ) {
                  assetsBreakdown[x][key][index][account[s][a].field] = account[s][a].value;
                }
              }

            }
          }          

        }

      }

      for ( var x in this.$data.worth.liabilities ) {

        liabilities[x] = {};
        liabilitiesBreakdown[x] = [];

        for ( var y in this.$data.worth.liabilities[x] ) {

          var key = this.$data.worth.liabilities[x][y].key;
          val = this.getRepeaterValues(
            this.$data.worth.liabilities[x][y].field,
            this.$data.worth.liabilities[x][y].totalby
          );

          total -= Number(val.total);          

          liabilities[x][key] = val;
          liabilitiesBreakdown[x][key] = [];

          account = this.$store.getters.getRepeaterData({field: this.$data.worth.liabilities[x][y].field});
          for ( var r in account ) {
            liabilitiesBreakdown[x][key][r] = {
              spouse: false
            }
            for ( var a in account[r] ) {
              liabilitiesBreakdown[x][key][r][account[r][a].field] = account[r][a].value;
            }
          }
          if ( this.hasSpouse() ) {
            if ( this.useSpouse() ) {
              var r = liabilitiesBreakdown[x][key].length
              account = this.$store.getters.getRepeaterData({field: this.$data.worth.liabilities[x][y].field, spouse: true})
              for ( var s in account ) {
                var index = Number(r) + Number(s);
                    index += '';
                liabilitiesBreakdown[x][key][index] = {
                  spouse: true
                }
                for ( var a in account[s] ) {
                  liabilitiesBreakdown[x][key][index][account[s][a].field] = account[s][a].value;
                }
              }

            }
          } 

        }

      }

      window.tables.netWorth = {
        total: total,
        assets: assets,
        assetsBreakdown: assetsBreakdown,
        liabilities: liabilities,
        liabilitiesBreakdown: liabilitiesBreakdown,
      };

      return true;

    },


     /**
     * ---------------------------------------------------------------------------- /
     * 
     * SPOUSE METHODS
     *
     * These methods are used to control how spouse details are rendered within the
     * report component.
     * 
     * --------------------------------------------------------------------------- */


    /**
     * METHOD: hasSpouse()
     * @return {Boolean} - returns whether or not the client has a spouse.
     *
     * This method simply tells the report component whether or not the current client
     * HAS a spouse profile connected to their data. It does NOT control whether 
     * that data is used. Display is controlled by the useSpouse() method.
     */
    hasSpouse() {

      var spouse = this.$store.getters.getClientSpouse();

      if ( spouse !== false &&
           spouse !== '' ) {

        return true;

      }

    },


    /**
     * METHOD: useSpouse()
     * @return {Boolean} - return whether or not to include spouse data in the report.
     *
     * This method simply tells the report whether or not to include spouse data in the
     * component report. It does so by check the spouseReport field within the client data,
     * which is attached to a checkbox component within the report. 
     */
    useSpouse() {

      if ( this.$store.getters.getClientSpouseData() !== false ) { 
        return this.$store.getters.getFieldData({ field: 'details.spouseReport' });
      }

    },


    /** 
     * METHOD: toggleUseSpouse() 
     * 
     * This method was previously used to control whether the spouse data was included
     * in the report. This was deprecated when the control value for this was added
     * to the client profile for the sake of persistence.
     */
    toggleUseSpouse() {

      return this.$data.spouse = ! this.$data.spouse;

    }, 
    

     /**
     * ---------------------------------------------------------------------------- /
     * 
     * SHOW METHODS
     *
     * These methods are used by the report component to help control whether or
     * not certain elements are rendered.
     * 
     * --------------------------------------------------------------------------- */       


    /**
     * METHOD: showTotalAreaChart()
     * @param  {String} type - a string indicating the general type to total (assets/liabilities)
     * @return {Boolean} - return whether or not the chart should be rendered.
     *
     * This method is used to determine whether or not the pie chart should be rendered for the
     * assets and liabilities section. If there is only a single data point for the given type, 
     * the chart will not be rendered (as it would be a single segment of 100%). If there is more
     * than a single data point, the chart is rendered.
     */
    showTotalAreaChart(type = 'assets') {

      var data = this.chartTotalArea(type);

      var x = 0;
      for ( var k in data ) {

        x += 1;

      }

      if ( x > 0 ) {

        return true;

      }

      return false;

    },


    /**
     * METHOD: showNetWorthChart()
     * @return {Boolean} - return whether or not the chart should be rendered.
     *
     * This method is used to determine whether or not the Net Worth chart should be rendered.
     * Checks to determine whether both assets total and liabilities total equal zero. If they 
     * are, there is no actual worth, so the chart is not rendered.
     */
    showNetWorthChart() {

      var data = this.chartNetWorth();

      if (data.assets.data[0] === 0 && data.liabilities.data[1] === 0 ) {

        return false;

      } 

      return true;

    },    


    /**
     * METHOD: showDisclaimer()
     * @return {Boolean} - Returns whether or not to render a disclaimer within the
     * body of the report. 
     * 
     * This method controls whether or not default disclaimer text is rendered in the report.
     * When the PDF report generation was added, the previous method was rendered somewhat 
     * redundant, but the functionality is maintained for instances where
     * the browser's own print functionality may be used.
     */
    showDisclaimer() {

      return this.$store.getters.getDisclaimer();

    },

    /**
     * METHOD: showClientInfo()
     * @return {String} - Returns a string containing client name and address information
     *
     * This method controls the client information that is outputted at the top of the report.
     * When the PDF report generation was added, the previous method was rendered somewhat 
     * redundant, but the functionality is maintained for instances where
     * the browser's own print functionality may be used.
     */
    showClientInfo() {

      var name = this.$store.getters.getCurrentClientName();
          name.trim();

      var html = '<div class="report__client-name">' + name + '</div>';

      html += this.$store.getters.getAddress({field: 'details.address'});

      return html;

    },



     /**
     * ---------------------------------------------------------------------------- /
     * 
     * FORMATTING METHODS
     *
     * These methods are used to format the output of certain types of values
     * within the report.
     * 
     * --------------------------------------------------------------------------- */

    /**
     * METHOD: getDollarFormat()
     * @param  {number} val - the numeric value that should be converted
     * @return {string} the value, formatted as a currency string
     *
     * This function is designed to connect into the global formatCurrency()
     * method defined at the window level.
     */
    getDollarFormat(val) {

      return window.formatCurrency(Number(val));

      if ( val.toFixed !== undefined ) {

        val = val.toFixed(2);

      }

      if ( val >= 0 ) {

        return '$' + window.thousandSeparators(val);

      }

      else {

        val *= -1;
        val = val.toFixed(2);
        return '<span class="negative">-$' + window.thousandSeparators(val) + '</span>';

      }

    },


     /**
     * ---------------------------------------------------------------------------- /
     * 
     * RETRIEVAL METHODS
     *
     * These methods are designed to pull values and totals out of the client data.
     * 
     * --------------------------------------------------------------------------- */

    /**
     * METHOD: getRepeaterValues()
     * @param  {String}  field - the name of the field to get the total value from
     * @param  {String}  totalby - a string representing how the total value should be calculated
     * @param  {Boolean} isdebt - a boolean indicating whether this is a debt or not
     * @return {Object} - returns an object with data about the total value of the repeater.
     *
     * This method is used to get the total value of a repeater field. The method is functionally distinct 
     * from the getRepeaterTotal() method in that the getRepeaterValues() returns an object containing three
     * different values:
     *
     * - client (the repeater value of the client)
     * - spouse (the repeater value of the spouse, if applicable)
     * - total (the total value of spouse + client, if applicable)
     *
     * The client value is only included if the spouse data has been activated by the user, this
     * method will also return information about the repeater value within the spouse profile as well.
     */
    getRepeaterValues(field, totalby, isdebt = false) {

      var totals = {
            client: 0,
            spouse: 0,
            total:  0
          };

      var vars = { 'field': field, 'totalby': totalby, 'spouse': false };

      if (vars.field) { 

        totals.client = this.$store.getters.getRepeaterTotal(vars);
        totals.total = totals.client;

        if ( this.hasSpouse() ) {

          if ( this.useSpouse() ) {

            vars.spouse = true;
            totals.spouse = this.$store.getters.getRepeaterTotal(vars);
            totals.total += totals.spouse;

            if ( isdebt ) {

              totals.spouse *= -1;

            }

          }

        }

        if ( isdebt ) {

          totals.total *= -1;
          totals.client *= -1;

        }

      }

      return totals;

    },


    /**
     * METHOD: getRepeaterTotal()
     * @param  {String}  field - the name of the field to get the total value from
     * @param  {String}  totalby - a string representing how the total value should be calculated
     * @param  {Boolean} isdebt - a boolean indicating whether this is a debt or not
     * @param  {Boolean} asString - a boolean indicating whether to return the value as a string
     * @return {String/Number} - If the asString parameter is true, return a formated string of the total value.
     * Otherwise, return the numeric value.
     *
     * This function actively works to retrieve the total value of a repeater field. It relies on the
     * getRepeaterValues() method to pull the actual values and totals. If the display mode (as set by the
     * asString parameter) is set to a string, it outputs the client value and (optional) spousal value
     * as two separate items. Otherwise, it simply returns the value of the total value returned by
     * the getRepeaterValues() method.
     */
    getRepeaterTotal(field, totalby, isdebt = false, asString = false) {
        
      var lineTotal = this.getRepeaterValues(field, totalby, isdebt),
          total = 0;

      if ( asString ) {

        if ( this.hasSpouse() ) {

          if ( this.useSpouse() ) {

            if ( lineTotal.spouse !== 0 ) {

              var spouse_name = this.$store.getters.getClientSpouseName();

              return this.getDollarFormat(lineTotal.client.toFixed(2)) + ' <div class="spouse"><span class="spouse__label">(' + spouse_name.firstName + ')</span> ' + this.getDollarFormat(lineTotal.spouse.toFixed(2)) + '</div>'

            }

          }

        }

        return this.getDollarFormat(lineTotal.total.toFixed(2));

      }

      else {

        total += lineTotal.total;
        return total.toFixed(2);

      }
      
      return lineTotal.client.toFixed(2);  

    },


    /**
     * METHOD: getSectionTotal()
     * @param  {String} section - a string indicating the section to total
     * @param  {String} type    - a string indicating the general type to total (assets/liabilities)
     * @return {String} - returns the total value of the section.
     *
     * This method is intended to get the total value for a specific section under either the assets
     * or liabilities grouping. For example, 'Liquid Assets' or 'Short Term Debt'.
     */
    getSectionTotal(section, type) {

      var total = 0,
          subtotal = 0,
          vars = {},
          fields = this.$data.worth[type][section];

      for ( var x = 0; x < fields.length; x++ ) {

        vars = this.$data.worth[type][section][x];
        subtotal = this.getRepeaterTotal(vars.field, vars.totalby);

        total += Number(subtotal);

      }

      if ( type === 'liabilities' ) {

        total *= -1;

      }

      return total.toFixed(2);

    },


    /**
     * METHOD: getTypeTotal()
     * @param  {String} type - a string indicating the general type to total (assets/liabilities)
     * @return {String} - returns the value for the type
     *
     * This method will return to total value for one of the two "types" of accounts, either
     * assets or liabilities.
     */
    getTypeTotal(type) {

      var total = 0,
          subtotal = 0,
          types = this.$data.worth[type];

      for ( var key in types ) {

        subtotal = this.getSectionTotal(key, type);

        total += Number(subtotal);

      }          

      return total.toFixed(2);

    },


    /**
     * METHOD: getNetWorth()
     * @return {Number} - returns the total net worth
     *
     * This method determined to total net worth of the client, by subtracting the total 
     * value of liabilities from the total value of assets.
     */
    getNetWorth() {

      var assets = this.getTypeTotal('assets'),
          liabilities = this.getTypeTotal('liabilities');

      return Number(liabilities) + Number(assets);

    },


    /**
     * ---------------------------------------------------------------------------- /
     * 
     * Charting Methods
     *
     * These methods are used specifically for handling the charting of the 
     * data tables that are used in the report's projections
     *
     * --------------------------------------------------------------------------- */ 

    
    /**
     * METHOD: chartNetWorth()
     * @return {Object} - return data object with all of the details to be passed to the chart for rendering.
     *
     * This method is used to build out the data object that is passed to the chart component in order
     * to actually render the primary net worth bar chart.
     */
    chartNetWorth() {

      var assets = this.getTypeTotal('assets'),
          liabilities = this.getTypeTotal('liabilities');

      return {

        labels: [this._translate('netWorth.assetsTotal'), this._translate('netWorth.liabilities'), this._translate('netWorth.netWorth')],
        assets: {
          data: [Number(assets), 0, 0],
          label: 'netWorth.assets::slug:assets',
          color: 1,
        },
        liabilities: {
          data: [0, Math.abs(Number(liabilities)), 0],
          label: 'netWorth.liabilities::slug:liabilities',
          color: 5,
        },        
        networth: {
          data: [0, 0, Number(assets) + Number(liabilities),],
          label: 'netWorth.netWorth::slug:netWorth',
          color: 0,
        },
      };
      
    },
    

    /**
     * METHOD: chartTotalArea()
     * @param  {String} type a string indicating the general type to be charted (assets/liabilities)
     * @return {Object} - return data object with all of the details to be passed to the chart for rendering.
     *
     * This method is used to build out the data object that is passed to the chart component in order
     * to actually render either the total assets or total liabilities pie chart, as determined by the 
     * type parameter.
     */
    chartTotalArea(type = 'assets') {

      var chartData = {};

      var x = 1;
      for ( var g in this.$data.worth[type] ) {

        for ( var k in this.$data.worth[type][g] ) {
        
          var value = this.getRepeaterTotal(
            this.$data.worth[type][g][k].field,
            this.$data.worth[type][g][k].totalby
          );

          if ( value > 0 ) {
            chartData[this.$data.worth[type][g][k].key] = {
              value: value,
              label: this.$data.worth[type][g][k].label + '::slug:' + this.$data.worth[type][g][k].key,
            }
          }

          x += 1;

        }

      }

      return chartData;
      
    },

  },


  /**
   * COMPUTED
   * --------
   * 
   * These functions are used to return computed values, which
   * can be bound to certain portions of the component.
   */  

  computed: {


  },

  /**
   * Component data
   * The component data uses an extensive data object, which breaks the assets and liabilities
   * into types (assets/liabilities) and groupings. Each account type also has its own
   * object, which defines:
   *
   * - field: the repeater field that is connected
   * - totalby: the method for totaling the repeater
   * - label: the label to use in the report; should use a key from the translation table.
   * - key: the textual key associated with the account type
   */
  data: function() {

    return {

      spouse: false,

      worth: {

        assets: {

          liquid: [
            
            { 
              field: 'savings.open.chequing', 
              totalby: 'balance',
              label: 'netWorth.chequing',
              key: 'open_chequing',
            },

            { 
              field: 'savings.open.savings',  
              totalby: 'balance',
              label: 'netWorth.savings',
              key: 'open_savings',
            }, 

          ],

          semiliquid: [

            { 
              field: 'savings.open.tfsa', 
              totalby: 'balance',
              label: 'netWorth.tfsa',
              key: 'registered_tfsa',
            },          
            
            // { 
            //   field: 'savings.open.bonds',        
            //   totalby: 'balance',
            //   label: 'Bonds',
            //   key: 'open_bonds',
            // },

            
            { 
              field: 'savings.open.stocks',       
              totalby: 'balance',
              label: 'netWorth.stocks',
              key: 'open_stocks',
            },

            
            { 
              field: 'savings.open.mutualFunds',  
              totalby: 'balance',
              label: 'netWorth.mutualFunds',
              key: 'open_mutualFunds',
            },

            
            // { 
            //   field: 'savings.open.gics',         
            //   totalby: 'balance',
            //   label: 'GICs',
            //   key: 'open_gics',
            // },

            
            { 
              field: 'savings.open.other',        
              totalby: 'balance',
              label: 'netWorth.other',
              key: 'open_other',
            },

          ],

          retirement: [

            // { 
            //   field: 'savings.registered.savings', 
            //   totalby: 'balance',
            //   label: 'Registered Savings',
            //   key: 'registered_savings',
            // },

            
            // { 
            //   field: 'savings.registered.bonds',   
            //   totalby: 'balance',
            //   label: 'Registered Bonds',
            //   key: 'registered_bonds',
            // },

            
            { 
              field: 'savings.registered.mutualFunds',   
              totalby: 'balance',
              label: 'netWorth.registeredMutualFunds',
              key: 'registered_mutualFunds',
            },

            
            // { 
            //   field: 'savings.registered.gics',    
            //   totalby: 'balance',
            //   label: 'Registered GICs',
            //   key: 'registered_gics',
            // },

            { 
              field: 'savings.registered.other',   
              totalby: 'balance',
              label: 'netWorth.otherRegistered',
              key: 'registered_other',
            },        

            
            { 
              field: 'savings.registered.rrif',   
              totalby: 'balance',
              label: 'netWorth.rrifs',
              key: 'registered_rrif',
            },
            
            { 
              field: 'savings.lockedin.employerPension',   
              totalby: 'balance',
              label: 'netWorth.employerPension',
              key: 'lockedin_employerPension',
            },

            { 
              field: 'savings.registered.dpspEsopGrsp',    
              totalby: 'balance',
              label: 'netWorth.dpspEsopGrsp',
              key: 'registered_dpspEsopGrsp',
            },

            { 
              field: 'savings.lockedin.lockedRrsp',   
              totalby: 'balance',
              label: 'netWorth.lockedinRrsp',
              key: 'lockedin_lockedRrsp',
            },        


          ],

          realestate: [
            
            { 
              field: 'assets.realEstate.home',  
              totalby: 'value',
              label: 'netWorth.familyHome',
              key: 'realestate_home',
            },
            
            { 
              field: 'assets.realEstate.other', 
              totalby: 'value',
              label: 'netWorth.otherRealEstate',
              key: 'realestate_other',
            },

          ],

          property: [
            
            { 
              field: 'assets.other.other',  
              totalby: 'value',
              label: 'netWorth.otherAssets',
              key: 'property_other',
            },

          ],

          other: [
            
            { 
              field: 'assets.other.taxDefered',  
              totalby: 'value',
              label: 'netWorth.taxDeferredAssets',
              key: 'other_taxDefered',
            },

          ],          

          business: [
            
            { 
              field: 'assets.other.businessInterests',  
              totalby: 'value',
              label: 'netWorth.businessInterests',
              key: 'business_interests',
            },

          ],          

        },

        liabilities: {

          shortterm: [
            
            { 
              field: 'debt.shortTerm.creditCards',    
              totalby: 'balance',
              label: 'netWorth.creditCards',
              key: 'debt_creditCards',
            },

            
            { 
              field: 'debt.shortTerm.carLoans',   
              totalby: 'balance',
              label: 'netWorth.carLoans',
              key: 'debt_carLoans',
            },
            
            { 
              field: 'debt.shortTerm.lineOfCredit', 
              totalby: 'balance',
              label: 'netWorth.lineOfCredit',
              key: 'debt_lineOfCredit',
            },
            
            { 
              field: 'debt.shortTerm.other',    
              totalby: 'balance',
              label: 'netWorth.otherLiabilities',
              key: 'debt_other',
            },

          ],

          longterm: [
            
            { 
              field: 'debt.longTerm.mortgageHome',  
              totalby: 'balance',
              label: 'netWorth.mortgageOnHome',
              key: 'debt_mortgageHome',
            },
            
            { 
              field: 'debt.longTerm.mortgageOther', 
              totalby: 'balance',
              label: 'netWorth.otherMortgages',
              key: 'debt_mortgageOther',
            },
            
            { 
              field: 'debt.longTerm.investmentLoans', 
              totalby: 'balance',
              label: 'netWorth.investmentLoans',
              key: 'debt_investmentLoans',
            },

          ],

        }

      }

    }

  }

}

</script>

<style lang="scss">

  .net-worth-wrap {

    .checkbox-wrap {

      margin-bottom: 0;
      padding: 1rem;
      transform: translate3d(0, .35rem, 0);
      background: #fff;

    }

    .checkbox__input {

      width: 1rem;
      height: 1rem;
      box-shadow: none;
      margin-right: .75rem;

      &::after {

        background: #06a0df;
        top: 3px;
        left: 3px;
        right: 3px;
        bottom: 3px;
        border-radius: 1px;

      }      

    }

    .label {

      color: #555;
      font-size: .8rem;
      display: inline;
      font-style: italic;
      letter-spacing: 0;

    }

  }

  .net-worth__assets,
  .net-worth__liabilities {

    background: #fff;

    .net-worth__type-heading {

      padding: 1rem;
      border-bottom: 1px solid #eee;

    }

  }

  .net-worth__section {

    border: 1px solid #eee;
    margin: 1rem 0;
    border-radius: 2px;
    background: #fff;

    h4 {

      background: #eee;
      padding: 1rem;
      border-radius: 2px 2px 0 0;

    }

    .chart-wrap {

      margin: 1.5rem -1rem 0;

    }

    .chart {

      margin: 0;

      canvas {

        max-width: 100%;
        max-height: 100%;

      }

    }    

  }

  .net-worth__value {

      color: #06a0df;

      .negative {

        color: #ed7220;

      }

      .spouse {

        margin-top: .35em;

      }

      .spouse__label {

        display: inline-block;

        color: #999;
        font-size: .8em;

        transform: translate3d(-.25em, -.1em, 0);

      }

  }

  .net-worth__type-heading {

    margin-top: 2.5rem;

  }

  .net-worth__total {

    font-size: 1.4em;
    padding: 1rem;

    .net-worth__value {

      font-size: 2em;

      display: block;

    }

  }

  .net-worth__list {

    list-style-type: none;
    padding: 0;

  }

  .net-worth__section-heading,
  .net-worth__list-item {

    padding: 1rem;
    display: flex;

    span {

      flex-grow: 1;

    }

    .net-worth__value {

      width: 200px;
      flex-grow: 0;
      text-align: right;

    }

  }

  .net-worth__list-item {

    border-bottom: 1px solid #eee;

    &:last-child {

      border: 0;

    }

  }

  .net-worth__list-label {

    display: block;

  } 

</style>


// WEBPACK FOOTER //
// NetWorth.vue?bbf10f1c